//import Swal from "sweetalert2";
//import Vue from "vue";
import {
    getBanks,
    getBestSalesReport,
    getBillReport,
    getChequeReport,
    getCurrentGiroReport,
    getCurrentPerformanceReport, getCurrentVisitReport,
    getGeneralDebtStatementReport,
    getInvoiceProfitabilityReport,
    getSafeReport,
    getSalesPersonGiroReport,
    getSalesPersonStockSaleReport,
    getStockAnalysisReport,
    getNewCurrentReport,
} from "@/services/modules/reports/reportService";

import {accountTypeConverter, numberConverter} from "../../../helpers";
import {formattedDate} from "@/momentHelper";
import store from "@/state/store";

export const state = {
    reportErrorMessage: "",
    reportList: [],
    reportFilterList: [],
    reportListData: [],
    reportListHeaders: [],
    bankList: [],
    bankListMetaData: [],
    bankListLoading: false,
    bankListHeaders: [],
    bankDetailList: [],
    bankDetailListLoading: false,
    noBankMessage: "",
    visitReportList: {
        currentVisits: [],
        orders: [],
        payments: []
    },
    visitReportListHeaders: {
        currentVisitHeaders: [],
        ordersHeaders: [],
        paymentsHeaders: [],
    },
    reportTypeTest: "",
    reportListSlots: [],
};

export const mutations = {
    setErrorMessage(state, data) {
        state.reportErrorMessage = data;
    },
    setReportList(state, data) {
        state.reportList = data;
    },
    setReportFilterList(state, data) {
        state.reportFilterList = data;
    },
    setReportListHeaders(state, data) {
        state.reportListHeaders = data;
    },
    setReportListData(state, data) {
        state.reportListData = data;
    },
    setBankList(state, data) {
        state.bankList = data;
    },
    setBankListLoading(state, data) {
        state.bankListLoading = data;
    },
    setBankListMetaData(state, data) {
        state.bankListMetaData = data;
    },
    setBankListHeaders(state, data) {
        state.bankListHeaders = data;
    },
    setNoBankMessage(state, data) {
        state.noBankMessage = data;
    },
    setBankDetailListLoading(state, data) {
        state.bankDetailListLoading = data;
    },
    setVisitReportList(state,data) {
        state.visitReportList = data;
    },
    setReportType(state,data) {
        state.reportTypeTest = data;
    },

    setVisitReportListCurrentVisits(state,data) {
        state.visitReportList.currentVisits = data;
    },
    setVisitReportListOrders(state,data) {
        state.visitReportList.orders = data;
    },
    setVisitReportListPayments(state,data) {
        state.visitReportList.payments = data;
    },

    setVisitReportListCurrentVisitsHeaders(state,data) {
        state.visitReportListHeaders.currentVisitHeaders = data;
    },
    setVisitReportListOrdersHeaders(state,data) {
        state.visitReportListHeaders.ordersHeaders = data;
    },
    setVisitReportListPaymentsHeaders(state,data) {
        state.visitReportListHeaders.paymentsHeaders = data;
    },

    setReportListSlots(state, data) {
        state.reportListSlots = data;
    }

}

export const getters = {};

export const actions = {
    async fetchBankList(context, {params, body}, loading) {
        context.commit("setBankListLoading", true)
        let result = await getBanks({params, body, loading})
        result.data.data.map(item => item.debit = numberConverter(item.debit))
        result.data.data.map(item => item.credit = numberConverter(item.credit))
        result.data.data.map(item => item.balance = numberConverter(item.balance))
        result.data.data.map(item => item.accountType = accountTypeConverter(item.accountType))


        context.commit("setBankListMetaData", {
            totalCount: result.data.totalCount,
            totalPages: result.data.totalPages
        });

        let headers = [
            {
                key: 'accountCode',
                label: 'Hesap Kodu',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'description',
                label: 'Açıklama',
                sortable: false,
                visible: true,
                class: "text-left align-middle",

            },
            {
                key: 'bankName',
                label: 'Banka Adı',
                sortable: false,
                visible: true,
                class: "text-left align-middle",

            },
            {
                key: 'accountType',
                label: 'Hesap Tipi',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'debit',
                label: 'Borç',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'credit',
                label: 'Alacak',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'balance',
                label: 'Bakiye',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
        ];

        context.commit('setBankListHeaders', headers);
        context.commit("setBankListLoading", false)
        if (result.data.success) {
            context.commit("setBankList", result.data.data);
            return result.data.data;
        } else {
            context.commit("setBankList", []);
            context.commit("setNoBankMessage", result.data.message);
            return [];
        }

    },
    async initReportList(context) {
        let reportListArray = [
            {
                title: 'Fatura Karlılık Raporu',
                description: 'Fatura karlılık raporunuzu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-chart-line-variant',
                url: 'invoice-profitability'
            },
            {
                title: 'Stok Analiz Raporu',
                description: 'Stok analiz raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-chart-bell-curve',
                url: 'stock-analysis'
            },
            {
                title: 'Hedef & Potansiyel Cari Raporu',
                description: 'Hedefler ve potansiyellerle ilgili cari raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-finance',
                url: 'current-giro-list'
            },
            {
                title: 'Hedef & Potansiyel Plasiyer Raporu',
                description: 'Hedefler ve potansiyellerle ilgili plasiyer raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-finance',
                url: 'salesperson-giro-list'
            },
            {
                title: 'Plasiyer Ürün Satış Raporu',
                description: 'Plasiyerlerinizin ürün satış raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-chart-pie',
                url: 'salesperson-stock-sale'
            },
            {
                title: 'En İyi Satış Raporu',
                description: 'Müşterilerinizin grup bazında en iyi satışlarını buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-podium-gold',
                url: 'best-sales'
            },
            {
                title: 'Cari Performans Raporu',
                description: 'Müşterilerinizin hareket performanslarını buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-chart-line-stacked',
                url: 'current-performance'
            },
            {
                title: 'Genel Borç/Alacak',
                description: 'Genel borç/alacak raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-bank-transfer',
                url: 'general-debit-credit'
            },
            {
                title: 'Çek Raporu',
                description: 'Çek raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-checkbook',
                url: 'report-cheque'
            },
            {
                title: 'Senet Raporu',
                description: 'Senet raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-text-box-outline',
                url: 'report-bill'
            },
            {
                title: 'Kasa Raporu',
                description: 'Kasa raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-wallet',
                url: 'report-safe'
            },
            {
                title: 'Ziyaret Raporu',
                description: 'Ziyaret raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-wallet-travel',
                url: 'visit-report'
            },
            {
                title: 'Yeni Cari Raporu',
                description: 'Yeni cari raporunu buradan görüntüleyebilirsiniz',
                filterList: [],
                icon: 'mdi-account',
                url: 'new-current-report'
            },
        ];
        context.commit("setReportList", reportListArray);
    },
    async fetchReport(context, {reportType, params, body}) {
        context;
        let headers = [];
        let result = false
        switch (reportType) {
            case 'Fatura Karlılık Raporu':
                result = await getInvoiceProfitabilityReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'date',
                        label: 'Tarih',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'documentNumber',
                        label: 'Belge No',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'currentName',
                        label: 'Cari İsim',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'saleCost',
                        label: 'Toplam Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'purchaseCost',
                        label: 'Alış Maliyeti',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'margin',
                        label: 'Kâr',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'rate',
                        label: 'Kâr Oranı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'process',
                        label: 'İşlem',
                        sortable: false,
                        class: "text-center align-middle",

                    }
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    context.commit('setReportListData', result.data.data);
                    const slots = ["saleCost", "purchaseCost", "margin", "rate"];
                    context.commit('setReportListSlots',slots);
                }

                break;
            case 'Stok Analiz Raporu':
                result = await getStockAnalysisReport(params, body);
                headers = [
                    {
                        key: 'stockCode',
                        class: "text-center align-middle",
                        label: 'Stok Kodu',
                        sortable: false,

                    },
                    {
                        key: 'stockName',
                        label: 'Stok Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'unit',
                        label: 'Birim',
                        class: "text-center align-middle",
                        sortable: false,
                    },
                    {
                        key: 'inputQuantity',
                        label: 'Giriş Miktarı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'inputAmount',
                        label: 'Giriş Tutarı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'outputQuantity',
                        label: 'Çıkış Miktarı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'outputAmount',
                        label: 'Çıkış Tutarı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'balance',
                        label: 'Bakiye',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'avgCost',
                        label: 'Ortalama Maliyet',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'cost',
                        label: 'Son Maliyet',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'leftAmount',
                        label: 'Kalan Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'purchaseCost',
                        label: 'Alış Maliyeti',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'margin',
                        label: 'Kâr',
                        sortable: false,
                        class: "text-center align-middle",

                    }
                ];

                if (store.state.settings.erpSettings.netsisCurrencySale) {
                    const additionalHeaders = [
                        {
                            key: 'inputCurrencyAmount',
                            label: 'Dövizli Giriş Tutarı',
                            sortable: true,
                            class: "text-center align-middle",

                        },
                        {
                            key: 'outputCurrencyAmount',
                            label: 'Dövizli Çıkış Tutarı',
                            sortable: true,
                            class: "text-center align-middle",

                        },
                        {
                            key: 'currencyMargin',
                            label: 'Dövizli Kar',
                            sortable: true,
                            class: "text-center align-middle",

                        },
                    ];
                    const indexOfInputAmount = headers.findIndex(header => header.key === 'inputAmount');
                    const indexOfOutputAmount = headers.findIndex(header => header.key === 'outputAmount');
                    const indexOfMargin = headers.findIndex(header => header.key === 'margin');

                    headers.splice(indexOfInputAmount + 1, 0, additionalHeaders.find((item) => item.key === 'inputCurrencyAmount'));
                    headers.splice(indexOfOutputAmount + 2, 0, additionalHeaders.find((item) => item.key === 'outputCurrencyAmount'));
                    headers.splice(indexOfMargin + 3, 0, additionalHeaders.find((item) => item.key === 'currencyMargin'));

                }

                context.commit('setReportListHeaders', headers);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["inputQuantity", "outputQuantity", "inputAmount", "outputAmount", "balance", "avgCost", "cost", "leftAmount", "purchaseCost", "margin", "inputCurrencyAmount", "outputCurrencyAmount", "currencyMargin"];
                    context.commit('setReportListSlots',slots);
                    context.commit('setReportListData', result.data.data)
                }

                break;
            case 'Hedef & Potansiyel Cari Raporu':
                result = await getCurrentGiroReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'currentCode',
                        class: "text-center align-middle",
                        label: 'Cari Kodu',
                        sortable: false,

                    },
                    {
                        key: 'currentName',
                        label: 'Cari Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'targetLimit',
                        label: 'Hedef Limit',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'targetRate',
                        label: 'Hedef Oran',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'potentialLimit',
                        label: 'Potansiyel Limit',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currencyPotentialRate',
                        label: 'Pazar Payı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'vatExcludedPrice',
                        label: 'KDV Hariç Ciro',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'vatIncludedPrice',
                        label: 'KDV Dahil Ciro',
                        sortable: false,
                        class: "text-center align-middle",

                    }
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["vatExcludedPrice", "vatIncludedPrice"];
                    result.data.data.map((item) => {
                        (item.currencyPotentialRate !== 0 && item.currencyPotentialRate) ? slots.push("currencyPotentialRate") : item.currencyPotentialRate = 'HEDEF YOK';
                        (item.potentialLimit !== 0 && item.potentialLimit) ? slots.push("potentialLimit") : item.potentialLimit = 'HEDEF YOK';
                        (item.targetRate !== 0 && item.targetRate) ? slots.push("targetRate") : item.targetRate = 'HEDEF YOK';
                        (item.targetLimit !== 0 && item.targetLimit) ? slots.push("targetLimit") : item.targetLimit = 'HEDEF YOK';
                    })
                    context.commit('setReportListSlots',slots);
                    context.commit('setReportListData', result.data.data)
                }

                break;
            case 'Hedef & Potansiyel Plasiyer Raporu':
                result = await getSalesPersonGiroReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'salesPersonCode',
                        class: "text-center align-middle",
                        label: 'Kodu',
                        sortable: false,

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'targetLimit',
                        label: 'Hedef Ciro',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'targetRate',
                        label: 'Hedef',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'potentialLimit',
                        label: 'Potansiyel Ciro',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currencyPotentialRate',
                        label: 'Pazar Payı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'vatIncludedCurrencyPrice',
                        label: 'Dövizli Ciro',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'vatIncludedPrice',
                        label: 'Ciro',
                        sortable: false,
                        class: "text-center align-middle",

                    }
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {

                    const slots = ["vatIncludedCurrencyPrice", "vatIncludedPrice"];
                    result.data.data.map((item) => {
                        (item.currencyPotentialRate !== 0 && item.currencyPotentialRate) ? slots.push("currencyPotentialRate") : item.currencyPotentialRate = 'HEDEF YOK';
                        (item.potentialLimit !== 0 && item.potentialLimit) ? slots.push("potentialLimit") : item.potentialLimit = 'HEDEF YOK';
                        (item.targetRate !== 0 && item.targetRate) ? slots.push("targetRate") : item.targetRate = 'HEDEF YOK';
                        (item.targetLimit !== 0 && item.targetLimit) ? slots.push("targetLimit") : item.targetLimit = 'HEDEF YOK';
                    })
                    context.commit('setReportListSlots',slots);
                    context.commit('setReportListData', result.data.data)

                }

                break;
            case 'Plasiyer Ürün Satış Raporu':
                result = await getSalesPersonStockSaleReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'stockCode',
                        class: "text-center align-middle",
                        label: 'Stok Kodu',
                        sortable: false,

                    },
                    {
                        key: 'stockName',
                        label: 'Stok Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'quantity',
                        label: 'Miktar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'unitPrice',
                        label: 'Birim Fiyat',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'amount',
                        label: 'Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currencyUnitPrice',
                        label: 'Dövizli Birim Fiyat',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currencyAmount',
                        label: 'Dövizli Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    result.data.data.map(item => item.salesPersonName = item.salesPersonName + ' (' + item.salesPersonCode + ')')
                    const slots = ["amount", "currencyAmount","currencyUnitPrice","unitPrice"];
                    context.commit('setReportListSlots',slots);
                    context.commit('setReportListData', result.data.data)
                }

                break;
            case 'En İyi Satış Raporu':
                result = await getBestSalesReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'currentCode',
                        class: "text-center align-middle",
                        label: 'Cari Kod',
                        sortable: false,

                    },
                    {
                        key: 'currentName',
                        label: 'Cari Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'salesPersonCode',
                        label: 'Plasiyer Kodu',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer Adı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'groupCode',
                        label: 'Grup Kod',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'groupName',
                        label: 'Grup Adı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currencySalesAmount',
                        label: 'Dövizli Satış Tutarı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'salesAmount',
                        label: 'Satış Tutarı',
                        sortable: false,
                        class: "text-center align-middle",

                    }
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["currencySalesAmount", "salesAmount"];
                    context.commit('setReportListSlots',slots);
                    context.commit('setReportListData', result.data.data)
                }
                break;
            case 'Cari Performans Raporu':
                result = await getCurrentPerformanceReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'currentCode',
                        class: "text-center align-middle",
                        label: 'Cari Kod',
                        sortable: false,

                    },
                    {
                        key: 'currentName',
                        label: 'Cari Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'stockCode',
                        label: 'Stok Kodu',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'stockCode',
                        label: 'Stok Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'quantity',
                        label: 'Miktar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currencySalesAmount',
                        label: 'Dövizli Satış Tutarı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'salesAmount',
                        label: 'Satış Tutarı',
                        sortable: false,
                        class: "text-center align-middle",

                    }
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["currencySalesAmount", "salesAmount"];
                    context.commit('setReportListSlots',slots);
                    result.data.data.map(item => item.salesPersonName = '(' + item.salesPersonCode + ') ' + item.salesPersonName)
                    result.data.data.map(item => item.quantity = numberConverter(item.quantity).slice(0, -3))
                    context.commit('setReportListData', result.data.data)
                }
                break;
            case 'Genel Borç/Alacak':
                context.commit("setReportType", "Genel Borç/Alacak");
                result = await getGeneralDebtStatementReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'currentCode',
                        class: "text-center align-middle",
                        label: 'Cari Kod',
                        sortable: false,

                    },
                    {
                        key: 'currentName',
                        label: 'Cari Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'salesPersonCode',
                        label: 'Plasiyer Kodu',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'phoneNumber',
                        label: 'Telefon',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'credit',
                        label: 'Borç',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'debit',
                        label: 'Alacak',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'balance',
                        label: 'Bakiye',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'city',
                        label: 'İl / İlçe',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'taxOffice',
                        label: 'Vergi Dairesi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'taxTrinNumber',
                        label: 'Vergi Numarası',
                        sortable: false,
                        class: "text-center align-middle",

                    }
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["credit", "debit","balance"];
                    context.commit('setReportListSlots',slots);
                    result.data.data.map(item => item.city = item.city + ' / ' + item.town)

                    context.commit('setReportListData', result.data.data)
                }
                break;
            case 'Çek Raporu':
                context.commit("setReportType", "Çek Raporu");
                result = await getChequeReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'documentNumber',
                        class: "text-center align-middle",
                        label: 'Belge No',
                        sortable: false,

                    },
                    {
                        key: 'inputDate',
                        label: 'Giriş Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'outputDate',
                        label: 'Çıkış Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'expiryDate',
                        label: 'Vade Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'principalDebtor',
                        label: 'Asıl Borçlu',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'givingName',
                        label: 'Veren Firma',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'givenName',
                        label: 'Verilen Firma',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'bankName',
                        label: 'Banka - Banka Şube',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'chequeCity',
                        label: 'Şehir - İlçe',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'chequeSerie',
                        label: 'Seri No',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'chequeStatus',// 3 protesto 0 null
                        label: 'Durum',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'location',// 2 Ciro 0 null
                        label: 'Yeri',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'amount',
                        label: 'Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["amount"];
                    context.commit('setReportListSlots',slots);
                    result.data.data.map(item => item.inputDate = item.inputDate ? formattedDate(item.inputDate, "DD-MM-YYYY") : null)
                    result.data.data.map(item => item.outputDate = item.outputDate ? formattedDate(item.outputDate, "DD-MM-YYYY") : null)
                    result.data.data.map(item => item.expiryDate = item.expiryDate ? formattedDate(item.expiryDate, "DD-MM-YYYY") : null)
                    result.data.data.map(item => item.bankName ? item.bankName = item.bankName + " - " + item.bankBranch ? item.bankBranch : "" : "")
                    result.data.data.map(item => item.chequeCity ? item.chequeCity = item.chequeCity + " - " + item.chequeTown : "")
                    result.data.data.map((item) => {
                        switch (item.chequeStatus) {
                            case 1:
                                item.chequeStatus = 'Ödendi'
                                break;
                            case 2:
                                item.chequeStatus = 'Beklemede'
                                break;
                            case 3:
                                item.chequeStatus = 'Portföy'
                                break;
                        }
                    });
                    result.data.data.map((item) => {
                        switch (item.location) {
                            case 0:
                                item.location = '-'
                                break;
                            case 1:
                                item.location = 'Portföy'
                                break;
                            case 2:
                                item.location = 'Ciro'
                                break;
                            case 3:
                                item.location = 'Tahsil'
                                break;
                            case 4:
                                item.location = 'Teminat'
                                break;
                            case 5:
                                item.location = 'İade'
                                break;
                            case 6:
                                item.location = 'Avukat'
                                break;
                        }
                    })
                    context.commit('setReportListData', result.data.data)
                }
                break;
            case 'Senet Raporu':
                context.commit("setReportType", "Senet Raporu");
                result = await getBillReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'documentNumber',
                        class: "text-center align-middle",
                        label: 'Belge No',
                        sortable: false,

                    },
                    {
                        key: 'inputDate',
                        label: 'Giriş Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'outputDate',
                        label: 'Çıkış Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'expiryDate',
                        label: 'Vade Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'principalDebtor',
                        label: 'Asıl Borçlu',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'givingName',
                        label: 'Veren Firma',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'givenName',
                        label: 'Verilen Firma',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'bankName',
                        label: 'Banka - Banka Şube',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'billCity',
                        label: 'Şehir - İlçe',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'billSerie',
                        label: 'Seri No',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'billStatus',// 3 protesto 0 null
                        label: 'Durum',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'location',// 2 Ciro 0 null
                        label: 'Yeri',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'amount',
                        label: 'Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["amount"];
                    context.commit('setReportListSlots',slots);
                    result.data.data.map(item => item.inputDate = item.inputDate ? formattedDate(item.inputDate, "DD-MM-YYYY") : null)
                    result.data.data.map(item => item.outputDate = item.outputDate ? formattedDate(item.outputDate, "DD-MM-YYYY") : null)
                    result.data.data.map(item => item.expiryDate = item.expiryDate ? formattedDate(item.expiryDate, "DD-MM-YYYY") : null)
                    result.data.data.map(item => item.bankName ? item.bankName = item.bankName + " - " + item.bankBranch : "")
                    result.data.data.map(item => item.chequeCity ? item.chequeCity = item.chequeCity + " - " + item.chequeTown : "")
                    result.data.data.map((item) => {
                        switch (item.billStatus) {
                            case 1:
                                item.billStatus = 'Ödendi'
                                break;
                            case 2:
                                item.billStatus = 'Beklemede'
                                break;
                            case 3:
                                item.billStatus = 'Portföy'
                                break;
                        }
                    });
                    result.data.data.map((item) => {
                        switch (item.location) {
                            case 0:
                                item.location = '-'
                                break;
                            case 1:
                                item.location = 'Portföy'
                                break;
                            case 2:
                                item.location = 'Ciro'
                                break;
                            case 3:
                                item.location = 'Tahsil'
                                break;
                            case 4:
                                item.location = 'Teminat'
                                break;
                            case 5:
                                item.location = 'İade'
                                break;
                            case 6:
                                item.location = 'Avukat'
                                break;
                        }
                    })
                    context.commit('setReportListData', result.data.data)
                }
                break;
            case 'Kasa Raporu':
                context.commit("setReportType", "Kasa Raporu");
                result = await getSafeReport(params, body);
                context.commit('setReportListHeaders', [
                    {
                        key: 'safeCode',
                        class: "text-center align-middle",
                        label: 'Kasa Kodu',
                        sortable: false,

                    },
                    {
                        key: 'safeName',
                        label: 'Kasa Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'branchCode',
                        label: 'Şube Kodu',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'date',
                        label: 'Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'documentNumber',
                        label: 'Belge No',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'status',
                        label: 'Durum',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'type',
                        label: 'Tip',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'description',
                        class: 'w-25 text-left align-middle',
                        label: 'Açıklama',
                        sortable: false,
                    },
                    {
                        key: 'amount',
                        label: 'Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer',
                        sortable: false,
                        class: "text-left align-middle",

                    }
                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    const slots = ["amount"];
                    context.commit('setReportListSlots',slots);
                    result.data.data.map(item => item.status = item.status === 1 ? 'Gelir' : 'Gider')
                    result.data.data.map((item) => {
                        switch (item.type) {
                            case 1:
                                item.type = 'Banka'
                                break;
                            case 2:
                                item.type = 'Cari'
                                break;
                            case 3:
                                item.type = 'Çek'
                                break;
                            case 4:
                                item.type = 'Fatura'
                                break;
                            case 5:
                                item.type = 'Muhtelif'
                                break;
                            case 6:
                                item.type = 'Senet'
                                break;
                            case 7:
                                item.type = 'Transfer'
                                break;
                        }
                    })
                    result.data.data.map(item => item.salesPersonName = item.salesPersonCode + " " + item.salesPersonName)
                    context.commit('setReportListData', result.data.data)
                }
                break;
            case 'Ziyaret Raporu':
                context.commit("setReportType", "Ziyaret Raporu");
                result = await getCurrentVisitReport(params, body);
                context.commit('setVisitReportListCurrentVisitsHeaders', [
                    {
                        key: 'currentCode',
                        class: "text-center align-middle",
                        label: 'Cari Kodu',
                        sortable: false,

                    },
                    {
                        key: 'currentName',
                        label: 'Cari Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer Adı',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'visitDate',
                        label: 'Ziyaret Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'authorizedName',
                        label: 'Yetkili Kişi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'description',
                        label: 'Açıklama',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                ]);
                context.commit("setVisitReportListOrdersHeaders", [
                    {
                        key: 'orderNumber',
                        label: 'Sipariş No',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'orderDate',
                        label: 'Tarih',
                        sortable: false,
                        class: "text-center align-middle",

                    }, {
                        key: 'expiryDate',
                        label: 'Vade Tarihi',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currentCode',
                        label: 'Cari Kodu',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'currentName',
                        label: 'Cari Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'salesPersonCode',
                        label: 'Plasiyer Kodu',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer Adı',
                        sortable: false,
                        class: "text-left align-middle",

                    },
                    {
                        key: 'totalAmount',
                        label: 'Toplam Tutar',
                        sortable: false,
                        class: "text-center align-middle",

                    },
                ])
                context.commit('setVisitReportListPaymentsHeaders', [
                    {
                        key: 'date',
                        label: 'Tarih',
                        sortable: false,
                    },
                    {
                        key: 'currentCode',
                        label: 'Cari Kodu',
                        sortable: false,
                    },
                    {
                        key: 'currentName',
                        label: 'Cari Adı',
                        sortable: false,
                    },
                    {
                        key: 'description',
                        label: 'Açıklama',
                        sortable: false,
                    },
                    {
                        key: 'salesPersonCode',
                        label: 'Plasiyer Kodu',
                        sortable: false,
                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer Adı',
                        sortable: false,
                    },
                    {
                        key: 'credit',
                        label: 'Alacak',
                        sortable: false,
                    },
                    {
                        key: 'type',
                        label: 'Tip',
                        sortable: false,
                    }

                ]);
                if (!result.data.success) {
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', [])
                    break;
                } else {
                    context.commit('setVisitReportListCurrentVisits',result.data.data.currentVisits);
                    context.commit('setVisitReportListOrders',result.data.data.orders);
                    context.commit('setVisitReportListPayments',result.data.data.payments);
                }
                break;

            case "Yeni Cari Raporu":
                context.commit("setReportType", "Yeni Cari Raporu");
                result = await getNewCurrentReport(params,body);
                context.commit("setReportListHeaders", [
                    {
                        key: 'code',
                        class: "text-center align-middle",
                        label: 'Cari Kodu',
                        sortable: false,
                    },
                    {
                        key: 'name',
                        label: 'Cari Adı',
                        sortable: false,
                        class: "text-left align-middle",
                    },
                    {
                        key: 'address',
                        label: 'Adres',
                        sortable: false,
                        class: "text-left align-middle",
                    },
                    {
                        key: 'city',
                        label: 'Şehir',
                        sortable: false,
                        class: "text-center align-middle",
                    },
                    {
                        key: 'town',
                        label: 'İlçe',
                        sortable: false,
                        class: "text-center align-middle",
                    },
                    {
                        key: 'taxOffice',
                        label: 'Vergi Dairesi',
                        sortable: false,
                        class: "text-center align-middle",
                    },
                    {
                        key: 'taxTrinNumber',
                        label: 'Vergi Numarası',
                        sortable: false,
                        class: "text-center align-middle",
                    },
                    {
                        key: 'taxOffice',
                        label: 'Vergi Dairesi',
                        sortable: false,
                        class: "text-center align-middle",
                    },
                    {
                        key: 'salesPersonName',
                        label: 'Plasiyer Adı',
                        sortable: false,
                        class: "text-center align-middle",
                    },
                    {
                        key: 'registeredUser',
                        label: 'Kayıt Eden',
                        sortable: false,
                        class: "text-center align-middle",
                    },
                    {
                        key: 'registeredDate',
                        label: 'Kayıt Tarihi',
                        sortable: false,
                        class: "text-center align-middle",
                    }
                ]);
                if (!result.data.success){
                    context.commit('setErrorMessage', result.data.message);
                    result = false;
                    context.commit('setReportListData', []);
                } else {
                    result.data.data.forEach((item) => {
                        item.registeredDate = formattedDate(item.registeredDate);
                    })
                    context.commit('setReportListData', result.data.data);
                }
                break;
            default:
                result = false;
                break;
        }
        return result;
    }


};
